import React, { useEffect, useState } from "react";
import BreadcrumbsHeader from "../breadcrumbs/BreadcrumbsHeader";
import Brands1 from "../brands/Brands1";
import { FaArrowRight, FaArrowLeft, FaLongArrowAltRight, FaPlay } from "react-icons/fa";
import Slider from "react-slick";
import "aos/dist/aos.css";
import AOS from "aos";


const faqs = [
  {
    question: "What's Pay-Per-Click (PPC)?",
    answer:
      "PPC is like an online bidding game. You create ads, and if someone clicks on them, you pay a small fee. It's a way to get your potential customers to visit your website.",
  },
  {
    question: "Why should I care about PPC for my business?",
    answer:
      "PPC ads show up when people search for things related to your business. So, it's like getting your ad in front of people who are already interested and looking to purchase the services offered by your Business.",
  },
  {
    question: "Where do these PPC ads show up?",
    answer:
      "They're on search engines like Google or Bing or social media platforms like Facebook and Instagram. These ads help businesses to reach out to potential customers in the most efficient way possible.",
  },
  {
    question: "How does PPC help my business shine?",
    answer:
      "Your ad appears at the top of the search results, so it's the first thing people see. That means more clicks, more visitors, and resulting in more customers.",
  },
  {
    question: "Is it worth paying for those clicks?",
    answer:
      "Absolutely! Since you're targeting people who are already interested, those clicks are more likely to turn into actual customers.",
  },
  {
    question: "Can I track if my PPC ads are working?",
    answer:
      "Definitely! You can see how many people clicked on your ad, what they did on your website, and even if they ended up buying something. Regular monitoring of PPC ads helps in implementing new policies with the data collected to improve the Business’s reach to customers.",
  },
];

const testimonials = [
  {
    name: "Arpan Ghosh",
    text: "The job which I appointed them was nicely done. The only thing I was concerned about was if they were authentic or not. But everything turned out good and these guys are 100% authentic. Highly recommended by me. I would love to work with these guys in the near future.",
    img: "/images/male-user.png",
  },
  {
    name: "Zeus",
    text: "I took the e-mail marketing service from them. They were highly dedicated towards their work and always kept me updated. After the splendid service they gave me for e-Mail marketing, I asked them for the Search Engine Optimization service as well. It also turned out well and I can actually see a change in my website. The reach of my website seems to be increased and I can also see new audiences checking my website. 5 stars to their work. 😉",
    img: "/images/male-user.png",
  },
  {
    name: "Mr. Badshah",
    text: "I appointed this company for e-mail marketing. To be honest, they did a splendid job. They completely nailed it. I can see the difference in my e-commerce business. If you are looking for a company for the e-mail marketing service, you can choose Digital India Leader blindfolded. 5 stars for there service.",
    img: "/images/male-user.png",
  },
  {
    name: "Sonia Sharma",
    text: "Best in class service. I hired them for a Search Engine Optimization service, they did a splendid job. I can legit see the positive response on my website and can see the reach has been increased in a drastic manner. Cheers to DIL team.",
    img: "/images/female-user.png",
  },
  {
    name: "Jason D. Sealey",
    text: "I hired them for PPC marketing. They provided me with good service. I am happy personalised attitude of dealing. Thanks to these people, my returns has increased and I can finally see a positive response on my website.",
    img: "/images/male-user.png",
  },
];



const PayPerClick = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const [openFAQ, setOpenFAQ] = useState(0);
    const NextArrow = ({ onClick }) => (
      <div className="custom-arrow next-arrow" onClick={onClick}>
        <FaArrowRight />
      </div>
    );
    
    const PrevArrow = ({ onClick }) => (
      <div className="custom-arrow prev-arrow" onClick={onClick}>
        <FaArrowLeft />
      </div>
    );

  return (
    <div>
      <BreadcrumbsHeader
        title="Pay Per Click"
        backgroundImage="/images/breadcrumbs/digital-marketing-cover.jpg"
      />

      {/* ========================= ENQUIRY SECTION ========================= */}
      <section className="section-home-secondary" id="enquire_now">
        <div className="b-home-about relative">
          <div className="vertical-container-top-mod vertical-left home-about-side-title hidden-md">
            <span className="vertical-text-main color-add text-uppercase">
              ISOLS Group
            </span>
            <span className="vertical-text-additional color-add-2 text-uppercase">
              DM
            </span>
          </div>

          <div className="container">
            <div className="row">
              {/* ===== LEFT SIDE CONTENT ===== */}
              <div className="col-xs-12 col-sm-6">
                <div className="b-mod-heading wow fadeInDown" data-aos="fadeInDown">
                  <p
                    className="first-heading font-secondary"
                    style={{ fontSize: 20, marginBottom: 10 }}
                  >
                    PAY PER CLICK ADVERTISING
                  </p>
                  <h2 className="heading-line line-right1 customColor customPseudoElBg">
                    <strong>Best PPC Services</strong>
                  </h2>
                  <p className="second-heading font-additional">
                    Being the best PPC Company in India, ISOLS AdWords Agency with its
                    tech-savvy professionals and tools, focus on deriving the best results
                    for the customers. Our exclusive approach to each project makes us a
                    prominent PPC Management Company in Delhi, Gurgaon and Noida. Keeping
                    in mind the best for your business, our PPC campaigns are ROI driven
                    with the best keyword research which will be the best for taking your
                    business to heights!
                  </p>
                </div>

                <div className="b-text">
                  <p>
                    <strong>
                      INCREASE YOUR BRAND'S VISIBILITY, DRIVE POTENTIAL AUDIENCE IN AND
                      IMPROVE YOUR CONVERSION RATE
                    </strong>
                  </p>
                  <p>
                    With the increasing competition in the market it is quite easy to get
                    lost in the mix. But with a trustworthy PPC Management Company like
                    ISOLS AdWords Agency you will always stand out of the crowd. PPC or Pay
                    Per Click Marketing strategizes your marketing campaigns in such a way
                    that you pay a minimal amount for the ads clicked. Our PPC services
                    make sure that your ad shows up at the very top of the search page. A
                    good PPC Advertising Agency like ours will make sure that your brand's
                    visibility grows along with your conversion rates.
                  </p>
                  <p>
                    With our team of certified professionals with the best marketing
                    strategies we guarantee, you are in good hands!
                  </p>
                </div>
              </div>

              {/* ===== RIGHT SIDE FORM ===== */}
              <div
                className="col-xs-12 col-sm-6 wow slideInLeft"
                data-aos="fadeInLeft"
              >
                <div className="footer-form wow fadeInDown" id="contact-form">
                 

                  <script
                    type="text/javascript"
                    dangerouslySetInnerHTML={{
                      __html: `(function (w, d, c) {
                        (w[c] = w[c] || []).push(function(flowluHost) {
                          try {
                            new FlowluForm.init({
                              id: 101591,
                              token: 'a1b962d0c1fb87354b47c32c88929ea2',
                              host: flowluHost
                            });
                          } catch(e){}
                        });
                        var n = d.getElementsByTagName("script")[0],
                            s = d.createElement("script"),
                            f = function () { n.parentNode.insertBefore(s, n); };
                        s.type = "text/javascript";
                        s.async = true;
                        s.src = "https://erp.isolsgroup.com/application/classes/Module/Crm/static/js/ext-form.js";
                        if (w.opera == "[object Opera]") { d.addEventListener("DOMContentLoaded", f, false); } else { f(); }
                      })(window, document, "flowlu_forms");`,
                    }}
                  />

                  {/* ==== FORM FIELDS ==== */}
                  <div
                    className="flowlu-form"
                    style={{ margin: "0 auto 15px", maxWidth: 700 }}
                  >
                     <h2
                    className="footer-form-title"
                    style={{ color: "#000", fontSize: 20 }}
                  >
                    SEEK EXPERT'S ADVICE &amp; GET PROPOSAL
                  </h2>
                    <input
                      type="text"
                      required
                      placeholder="Your Name*"
                      className="flowlu-input"
                      style={{
                        color: "#000",
                        background: "none",
                        border: "none",
                        borderBottom: "1px solid #000",
                        height: "50px",
                        marginBottom: "18px",
                      }}
                    />
                    <input
                      type="text"
                      required
                      placeholder="Your Company Name*"
                      className="flowlu-input"
                      style={{
                        color: "#000",
                        background: "none",
                        border: "none",
                        borderBottom: "1px solid #000",
                        height: "50px",
                        marginBottom: "18px",
                      }}
                    />
                    <input
                      type="email"
                      required
                      placeholder="Email Address*"
                      className="flowlu-input"
                      style={{
                        color: "#000",
                        background: "none",
                        border: "none",
                        borderBottom: "1px solid #000",
                        height: "50px",
                        marginBottom: "18px",
                      }}
                    />
                    <input
                      type="text"
                      required
                      placeholder="Mobile Number*"
                      className="flowlu-input"
                      style={{
                        color: "#000",
                        background: "none",
                        border: "none",
                        borderBottom: "1px solid #000",
                        height: "50px",
                        marginBottom: "18px",
                      }}
                    />
                    <textarea
                      rows="5"
                      placeholder="Type Your Query"
                      required
                      className="flowlu-input"
                      style={{
                        width: "100%",
                        border: "none",
                        borderBottom: "1px solid #000",
                        color: "#000",
                        background: "none",
                        height: "146px",
                      }}
                    ></textarea>

                    <div
                      className="flowlu-row-submit"
                      style={{ textAlign: "left" }}
                    >
                      <button
                        type="submit"
                        className="flowlu-submit btn-default-arrow"
                        style={{
                          color: "#ff9600",
                          background: "transparent",
                          border: "1px solid #ccc",
                          fontWeight: 700,
                          padding: "10px 32px",
                          textTransform: "uppercase",
                          letterSpacing: ".8px",
                          fontSize: "12px",
                          marginTop: "30px",
                        }}
                        onMouseOver={(e) => {
                          e.target.style.background = "#ff9600";
                          e.target.style.color = "#fff";
                        }}
                        onMouseOut={(e) => {
                          e.target.style.background = "transparent";
                          e.target.style.color = "#ff9600";
                        }}
                      >
                        <FaLongArrowAltRight
                          style={{ marginRight: 8, fontSize: 19 }}
                        />
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ========================= WHAT MAKES ISOLS SECTION ========================= */}
    <section className="b-home-services">
      <div className="container">
        <div className="b-services-holder1 clearfix">
          {/* ---- Row 1 ---- */}
          <div className="row">
            <div className="col-xs-12 col-sm-4">
              <div className="b-services-item wow fadeInUp">
                <div className="services-text">
                  <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                    Unique Strategies
                  </h6>
                  <p>
                    Our team of experts, after understanding your brand's
                    position, offer the most unique and effective strategies. We
                    use the latest tools and plan accordingly for our customer's
                    best interest.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-xs-12 col-sm-4">
              <div className="b-services-item wow fadeInUp">
                <div className="services-text">
                  <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                    Transparency
                  </h6>
                  <p>
                    At ISOLS AdWords Agency, we believe in clear communication
                    and understanding with our clients. The designated project
                    supervisors will keep you updated with the status of the
                    campaigns at every step.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-xs-12 col-sm-4">
              <div className="b-services-item wow fadeInUp">
                <div className="services-text">
                  <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                    Exclusive supervisor for each project
                  </h6>
                  <p>
                    We provide our best services to all our clients. We assign
                    exclusive project managers for each project for undivided
                    attention towards their respective projects.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* ---- Row 2 ---- */}
          <div className="row">
            <div className="col-xs-12 col-sm-4">
              <div className="b-services-item wow fadeInUp">
                <div className="services-text">
                  <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                    Qualified Leads @ Low Cost
                  </h6>
                  <p>
                    Our team of experts at ISOLS AdWords Agency will make sure
                    to get you more Qualified Leads at Low Cost.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-xs-12 col-sm-4">
              <div className="b-services-item wow fadeInUp">
                <div className="services-text">
                  <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                    Larger Motive
                  </h6>
                  <p>
                    Our effective outcome-driven team not only focuses on
                    increasing visibility and conversion rates but also helps
                    you build your brand and reach new heights.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* ---- End of Row 2 ---- */}
           </div>
      </div>
    </section>

 <section className="section-about">
        <div className="container">
    <div className="row">
      <h2
        className="vc_custom_heading vc_custom_1490112359046"
        style={{
          fontSize: "40px",
          color: "#ff9600",
          lineHeight: "1.2",
          textAlign: "center",
          fontFamily: "Raleway",
          fontWeight: 700,
          fontStyle: "normal",
          marginBottom: "50px",
        }}
      >
        BENEFITS FROM OUR PAY PER CLICK ADVERTISING SERVICES
      </h2>

      <div className="b-services-holder">
        {/* ---------- Row 1 ---------- */}
        <div className="row">
          <div className="col-md-4 col-xs-12 col-sm-4 wow slideInLeft">
            <div className="b-services-item">
              <div className="services-icon">
                <img
                  src="/images/ppc-02.png"
                  alt="Intensive Goal-oriented Campaigns icon"
                />
              </div>
              <div className="services-text ht400">
                <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                  Intensive Goal-oriented Campaigns
                </h6>
                <p>
                  We start by understanding our client's needs and agendas.
                  Based on that, our team frames the whole execution plan which
                  is centred on the brand's building. The strategies implemented
                  are outcome driven and have been proven effective. Our team of
                  experts will go to every extent to make sure that the desired
                  goal is achieved. A top PPC Company like ours will be the best
                  decision for your brand.
                </p>
              </div>
            </div>
          </div>

          <div className="col-md-4 col-xs-12 col-sm-4 wow fadeInDown">
            <div className="b-services-item">
              <div className="services-icon">
                <img
                  src="/images/ppc-goal-icon.png"
                  alt="Social Media Marketing icon"
                />
              </div>
              <div className="services-text ht400">
                <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                  The Most Effective Plan
                </h6>
                <p>
                  Our PPC advertising services with its result-driven agendas
                  make sure to provide the most effective plan needed for your
                  brand's building. Our professionals are organised and follow a
                  scheduled approach to the situation. We never take a step back
                  from challenges rather our team of expertise are trained to
                  face them at any given condition.
                </p>
              </div>
            </div>
          </div>

          <div className="col-md-4 col-xs-12 col-sm-4 wow slideInRight">
            <div className="b-services-item">
              <div className="services-icon">
                <img
                  src="/images/ppc-results.png"
                  alt="Projection of Results icon"
                />
              </div>
              <div className="services-text ht400">
                <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                  Projection of Results
                </h6>
                <p>
                  At ISOLS AdWords Agency, we believe in complete transparency
                  with our clients. Hence, we provide a routine update on the
                  status of the campaigns. We take into consideration your
                  doubts and queries and get back to you in time. We believe in
                  building a trustworthy and credible relationship with our
                  clients without any loopholes.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* ---------- Row 2 ---------- */}
        <div className="row">
          <div className="col-md-4 col-xs-12 col-sm-4 wow slideInLeft">
            <div className="b-services-item">
              <div className="services-icon">
                <img
                  src="/images/ppc-research.png"
                  alt="PPC Research icon"
                />
              </div>
              <div className="services-text ht400">
                <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                  Thorough Research
                </h6>
                <p>
                  Our pay per click advertising services are the best due to the
                  thorough research that goes behind it. We minutely follow your
                  sales graphs along with your targets which helps us to sketch
                  an efficient plan to benefit your business. Keeping in mind
                  the derivations from the research it helps us to curate the
                  best content and advertising strategies that help to attract
                  the crowd.
                </p>
              </div>
            </div>
          </div>

          <div className="col-md-4 col-xs-12 col-sm-4 wow fadeInUp">
            <div className="b-services-item">
              <div className="services-icon">
                <img
                  src="/images/ppc-services.png"
                  alt="Customized PPC services icon"
                />
              </div>
              <div className="services-text ht400">
                <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                  Customized PPC Services
                </h6>
                <p>
                  Our customer services are totally customized. We believe in
                  providing exclusive PPC services to each of our clients which
                  makes us amongst the top PPC Agencies in India. We sit with
                  each of our clients and understand their needs. Accordingly,
                  our group of professionals strategize the plan which will
                  derive the most effective outcome. We treat our clients
                  equally, the scale and size of the business doesn't matter.
                </p>
              </div>
            </div>
          </div>

          <div className="col-md-4 col-xs-12 col-sm-4 wow slideInRight">
            <div className="b-services-item">
              <div className="services-icon">
                <img
                  src="/images/brand-promotion.png"
                  alt="Brand Promotion icon"
                />
              </div>
              <div className="services-text ht400">
                <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                  Your Brand's Promotion
                </h6>
                <p>
                  As our PPC services not only focus on your traffic growth or
                  your conversion rates but also look at the wider scope,
                  something more than that. We make sure to give your brand its
                  much-deserved exposure. Our strategies make sure that it
                  contributes to your brand's building. Our techniques ignite
                  curiosity among your audience and drive them into your
                  website!
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* ---------- Row 3 ---------- */}
        <div className="row">
          <div className="col-md-4 col-xs-12 col-sm-4 col-lg-offset-2 wow slideInRight">
            <div className="b-services-item">
              <div className="services-icon">
                <img
                  src="/images/innovative.png"
                  alt="Innovative Ads icon"
                />
              </div>
              <div className="services-text ht400">
                <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                  Innovative Ads
                </h6>
                <p>
                  We always try to implement innovative techniques for your
                  brand which helps to drive potential audiences to your
                  website. We use various sorts of technical and graphical
                  contents that draw attention. Our team excels at creativity
                  and always thinks outside the box which makes your brand stand
                  out.
                </p>
              </div>
            </div>
          </div>

          <div className="col-md-4 col-xs-12 col-sm-4 wow slideInRight">
            <div className="b-services-item">
              <div className="services-icon">
                <img
                  src="/images/audience.png"
                  alt="Audience-Centric Approach icon"
                />
              </div>
              <div className="services-text ht400">
                <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                  Audience-Centric Approach
                </h6>
                <p>
                  We strategize all our plans keeping in mind your audience. We
                  try to analyse from their perspective and how they see the
                  world. Our team does extensive research to derive a concrete
                  understanding of your audience and accordingly launch the PPC
                  campaigns. These research-based strategies are the most
                  effective approaches and result in desired outcomes.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</div>
</section>

 
   <section className="section-about1">
      <div className="container">
        <div className="b-home-video-block">
          <div className="container-fluid">
            <div
              className="col-xs-12 col-sm-12 col-md-12 col-lg-12 left-side wow slideInLeft"
              style={{ visibility: "visible", animationName: "slideInLeft" }}
            >
              <div className="b-video-holder">
                <a
                  className="video-image playVideo1"
                  href="#"
                  data-toggle="modal"
                  data-target="#myModal"
                  data-title="#"
                >
                   <FaPlay className="demo-icon play-icon" /><br></br>
                  <span className="video-title">play the video</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

 <section className="section-services1">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-sm-12">
            <div className="text-center">
              <h2
                className="vc_custom_heading vc_custom_1490112359046"
                style={{
                  fontSize: "40px",
                  color: "#ff9600",
                  lineHeight: 1.2,
                  textAlign: "center",
                  fontFamily: "Raleway",
                  fontWeight: 700,
                  fontStyle: "normal",
                  marginTop:"50px",
                }}
              >
                A VISIT IS OF MORE WORTH THAN WHAT YOU PAY FOR IT!
              </h2>
              <p className="second-heading font-additional">
                Launching a successful PPC campaign can be a tricky job. It requires efficient strategies to drive in the potential audience into your website. That's why we, ISOLS AdWords Agency, one of the top PPC Management Company is here for you!
                <br />
                We make sure to provide you with more leads at a very low cost. Every visit can be a potential customer at your website and that can increase your sales. We help you to connect with your crowd. Our experts make sure to use the best strategies that deliver fastest results. Our top notch PPC services guide you to expand your profits. And having your brand's ad at the top of the search engine won't harm, right?
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div className="b-home-services">
      <div className="container">
        <div className="b-services-holder1 clearfix">
          {/* Service Item 1 */}
          <div className="row"></div>
          <div className="col-xs-12 col-sm-4">
            <div
              className="b-services-item wow fadeInLeft"
              style={{ visibility: "visible", animationName: "fadeInLeft" }}
            >
              <div className="services-text">
                <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                  Strategized Advertising
                </h6>
                <p>
                  At ISOLS AdWords Agency, our pocket friendly campaigns are
                  designed to provide you with the best experience and help you
                  with improved ROI. Our team makes sure to build your brand's
                  awareness and drive the targeted traffic into your website.
                </p>
              </div>
            </div>
          </div>

          {/* Service Item 2 */}
          <div className="col-xs-12 col-sm-4">
            <div className="b-services-item">
              <div className="services-text">
                <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                  Paid Search
                </h6>
                <p>
                  Our team makes sure that your brand gets the maximum exposure
                  and draws the most potential crowd to your website. By keeping
                  in mind the needs of our customers we make sure that your
                  brand's paid search marketing is a hit.
                </p>
              </div>
            </div>
          </div>

          {/* Service Item 3 */}
          <div className="col-xs-12 col-sm-4">
            <div
              className="b-services-item wow fadeInRight"
              style={{ visibility: "visible", animationName: "fadeInRight" }}
            >
              <div className="services-text">
                <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                  Shopping Ads
                </h6>
                <p>
                  With our effective retail-centric strategies a shopping ad
                  campaign can get better coverage.
                </p>
              </div>
            </div>
          </div>
</div>
<div className="row">
          {/* Service Item 4 */}
          <div className="col-xs-12 col-sm-4">
            <div
              className="b-services-item wow fadeInRight"
              style={{ visibility: "visible", animationName: "fadeInRight" }}
            >
              <div className="services-text">
                <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                  Remarketing techniques
                </h6>
                <p>
                  Our PPC campaign strategies make sure to provide you with
                  cost-effective remarketing techniques.
                </p>
              </div>
            </div>
          </div>

          {/* Service Item 5 */}
          <div className="col-xs-12 col-sm-4">
            <div
              className="b-services-item wow fadeInRight"
              style={{ visibility: "visible", animationName: "fadeInRight" }}
            >
              <div className="services-text">
                <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                  Best Media Buy
                </h6>
                <p>
                  We try to find the perfect media channels that best fit you
                  and your brand's needs which in turn help in building potential
                  views and results in increased ROI (Return on Investment).
                </p>
              </div>
            </div>
          </div>

          {/* Service Item 6 */}
          <div className="col-xs-12 col-sm-4">
            <div
              className="b-services-item wow fadeInRight"
              style={{ visibility: "visible", animationName: "fadeInRight" }}
            >
              <div className="services-text">
                <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                  Social Media Advertising
                </h6>
                <p>
                  This is the world of Social Media. Through social media
                  platforms like Facebook, Instagram and Twitter, along with
                  our effective marketing strategies your brand can draw a
                  potential crowd to your website.
                </p>
              </div>
            </div>
          </div>
</div>
          {/* Service Item 7 */}
          <div className="row">
          <div className="col-xs-12 col-sm-4 col-lg-offset-2">
            <div
              className="b-services-item wow fadeInRight"
              style={{ visibility: "visible", animationName: "fadeInRight" }}
            >
              <div className="services-text">
                <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                  HOUSE OF THE MOST EXCLUSIVE STRATEGIES!
                </h6>
                <p>
                  We don't believe one size fits all kind of strategies. From
                  the very beginning of our project we discuss your needs and
                  what you expect from our PPC services. Based on your
                  objectives and requirements we create an efficient,
                  cost-effective plan for your business. With our team of
                  certified experts who have a clear idea of the market, we
                  focus on giving you our best!
                </p>
              </div>
            </div>
          </div>

          {/* Service Item 8 */}
          <div className="col-xs-12 col-sm-4">
            <div
              className="b-services-item wow fadeInRight"
              style={{ visibility: "visible", animationName: "fadeInRight" }}
            >
              <div className="services-text">
                <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                  THE BEST PAY PER CLICK SERVICES WITHIN YOUR BUDGET!
                </h6>
                <p>
                  Our client's satisfaction is our top-most priority. At ISOLS
                  AdWords Agency, the experienced team of technicians offers you
                  their most creative strategies which leads to traffic growth
                  and improves your conversion rates. We aim at providing the
                  finest PPC campaigns within your budget, without compromising
                  the quality of our work. Our marketing acumen helps us to
                  achieve the most desired ROI and give your brand its
                  well-deserved visibility and voice.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Centered Paragraph */}
        <div className="row">
          <center style={{ marginTop: "44px" }}>
            <div className="p-sz">
              <p style={{ fontSize: "17px" }}>
                ISOLS AdWords Agency is the topmost PPC Management Company in
                India. We provide the best Pay Per Click Services within
                affordable prices. We ensure the best Pay Per Click advertising
                campaign services for our clients. We focus on your audience
                reach and increase your visibility along with your conversion
                rates. We work with you, for you!
              </p>
            </div>
          </center>
        </div>
      </div>
    </div>

 <section className="section-services" style={{ padding: "40px 0 0px" }}>
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-sm-12">
            <div className="b-mod-heading text-center">
              <h2
                className="vc_custom_heading vc_custom_1490112359046"
                style={{
                  fontSize: "40px",
                  color: "#ff9600",
                  lineHeight: 1.2,
                  textAlign: "center",
                  fontFamily: "Raleway",
                  fontWeight: 700,
                  fontStyle: "normal",
                }}
              >
                OUR PPC CAMPAIGN APPROACHES CAN TAKE YOUR BUSINESS TO HEIGHTS!
              </h2>
            </div>
          </div>
        </div>
      </div>
    </section>

     <section className="b-home-services" style={{ marginBottom: 0, paddingTop: 0 }}>
      <div className="container">
        <div className="b-services-holder clearfix" style={{ padding: 0 }}>

          {/* ---- Row 1 ---- */}
          <div className="row">
            <div className="col-xs-12 col-sm-3 ht300">
              <a href="/innovative-solution-technologies">
                <div className="b-services-item wow fadeInLeft" style={{ visibility: "visible", animationName: "fadeInLeft" }}>
                  <div className="services-text">
                    <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                      Analytics-Driven PPC Management Agency
                    </h6>
                    <p>
                      Our expertise comes from our desire to analyse every situation beforehand for a positive outcome. We analyse each and every aspect and move to point out and decide on the most effective strategies. With this we are capable of facing the challenges in time of dire straits. Keeping a track of our action and examining our errors help us in modifying are strategies for its betterment.
                    </p>
                  </div>
                </div>
              </a>
            </div>

            <div className="col-xs-12 col-sm-3 ht300">
              <a href="/digital-india-leader">
                <div className="b-services-item wow fadeInRight" style={{ visibility: "visible", animationName: "fadeInRight" }}>
                  <div className="services-text">
                    <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                      Outsourcing Services
                    </h6>
                    <p>
                      Our outsourcing services are client-friendly and within your budget. You need any help with your digital marketing services in your business, you can contact us. Our highly qualified experts will be there at your service.
                    </p>
                  </div>
                </div>
              </a>
            </div>

            <div className="col-xs-12 col-sm-3 ht300">
              <a href="/digital-payment-solutions">
                <div className="b-services-item wow fadeInRight" style={{ visibility: "visible", animationName: "fadeInRight" }}>
                  <div className="services-text">
                    <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                      Transparent Communication
                    </h6>
                    <p>
                      We believe a project can succeed based on crystal clear communication between every part of the project. We make sure you are updated with every detail and its progress. We consider your valuable inputs throughout the project as well. We make sure our client's have a clear picture of the whole campaign without any loopholes.
                    </p>
                  </div>
                </div>
              </a>
            </div>

            <div className="col-xs-12 col-sm-3 ht300">
              <a href="#">
                <div className="b-services-item wow fadeInRight" style={{ visibility: "visible", animationName: "fadeInRight" }}>
                  <div className="services-text">
                    <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                      Expand Online Brand Image
                    </h6>
                    <p>
                      We at ISOLS AdWords Agency, along with deriving short term results we also focus on the wider picture. We believe in building your brand's awareness and generating a buzz amongst the targeted audience which will result in a potential audience. This ensures driving in long-time customers for the future. A good image will help you move ahead of your competitors without worrying about any backlash.
                    </p>
                  </div>
                </div>
              </a>
            </div>
          </div>
          {/* ---- End of Row 1 ---- */}

          {/* ---- Row 2 ---- */}
          <div className="row">
            <div className="col-xs-12 col-sm-3 ht300">
              <a href="#">
                <div className="b-services-item wow fadeInRight" style={{ visibility: "visible", animationName: "fadeInRight" }}>
                  <div className="services-text">
                    <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                      Latest Trend Inclusion
                    </h6>
                    <p>
                      Our PPC Advertising specialists at ISOLS AdWords Agency keep themselves up to date to the modern trends. This helps us to have a head start of where and how to start. Our creative experts implement the latest trends, keeping in mind your brand's objectives and customise the campaigns accordingly to reach the wider range of audience.
                    </p>
                  </div>
                </div>
              </a>
            </div>

            <div className="col-xs-12 col-sm-3 ht300">
              <a href="#">
                <div className="b-services-item wow fadeInRight" style={{ visibility: "visible", animationName: "fadeInRight" }}>
                  <div className="services-text">
                    <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                      Properly Placed PPC Ads
                    </h6>
                    <p>
                      Along with generating PPC ads creativity lies in placing the ads in its most perfect position. The position of the ads plays an important role in order to attract the crowd into the websites. A cautious step is needed to take in order to place the ads keeping in mind all the agendas. Our team of professionals are highly qualified in understanding the market and where exactly the ads should be placed.
                    </p>
                  </div>
                </div>
              </a>
            </div>

            <div className="col-xs-12 col-sm-3 ht300">
              <a href="#">
                <div className="b-services-item wow fadeInRight" style={{ visibility: "visible", animationName: "fadeInRight" }}>
                  <div className="services-text">
                    <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                      Quicker Results
                    </h6>
                    <p>
                      Our team of expertise plans their steps in such a way that it generates effective results from the very first day of the campaign unlike other agencies. We keep a scheduled check on our progress and efficiently work on it.
                    </p>
                  </div>
                </div>
              </a>
            </div>

            <div className="col-xs-12 col-sm-3 ht300">
              <a href="#">
                <div className="b-services-item wow fadeInRight" style={{ visibility: "visible", animationName: "fadeInRight" }}>
                  <div className="services-text">
                    <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                      Competitive Analysis
                    </h6>
                    <p>
                      We while planning our steps keep in mind your competitors as well. With our extensive research we try to analyse their steps and focus on widening your brand's perspective. We make sure to always keep you a step ahead of your competitors.
                    </p>
                  </div>
                </div>
              </a>
            </div>
          </div>
          {/* ---- End of Row 2 ---- */}

        </div>
      </div>
    </section>


      <section>
    <div className="container" style={{ padding: "60px 0" }}>
  <div className="row">

    {/* LEFT SIDE – FAQ */}
    <div className="col-lg-6 col-md-12">
      <section className="faq-section">
        <h2 className="faq-title">ASK YOUR QUERIES?</h2>
        <p className="faq-subtitle">SEO FAQs</p>

        <div className="faq-box">
          {faqs.map((item, index) => (
            <div
              key={index}
              className={`faq-item ${openFAQ === index ? "active" : ""}`}
              onClick={() => setOpenFAQ(openFAQ === index ? null : index)}
            >
              <div className="faq-question">
                <span className="faq-icon">
                  {openFAQ === index ? "✖" : "➕"}
                </span>
                {item.question}
              </div>

              {openFAQ === index && (
                <div className="faq-answer">{item.answer}</div>
              )}
            </div>
          ))}
        </div>
      </section>
    </div>

    {/* RIGHT SIDE – TESTIMONIALS */}
    <div className="col-lg-6 col-md-12">
      <section className="testimonial-section">
  <h2 className="testimonial-title">What our clients say about us</h2>

  <Slider
    dots={true}
    infinite={true}
    speed={500}
    slidesToShow={1}
    slidesToScroll={1}
    autoplay={true}
    autoplaySpeed={3000}
    arrows={true}
    nextArrow={<NextArrow />}
    prevArrow={<PrevArrow />}
  >
    {testimonials.map((item, i) => (
      <div key={i} className="testimonial-card">
        <img src={item.img} alt="" className="testimonial-img" />
        <h4 className="testimonial-name">{item.name}</h4>
        <p className="testimonial-text">{item.text}</p>
      </div>
    ))}
  </Slider>
</section>

    </div>

  </div>
</div>

    </section>


    <section
      className="section-about1 sectionn"
      style={{ paddingBottom: "100px" }}
    >
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12">
            <h2
              style={{
                fontSize: "25px",
                color: "#ff9600",
                lineHeight: 1.2,
                textAlign: "center",
                fontFamily: "Raleway",
                fontWeight: 700,
                fontStyle: "normal",
                padding: "0 0 30px 0",
                textTransform: "uppercase",
              }}
              className="vc_custom_heading vc_custom_1490112359046"
            >
              What Our Client Feel About Us
            </h2>

            <div className="row">
              <div className="col-lg-4">
                <iframe
                  width="100%"
                  height="310"
                  src="https://www.youtube.com/embed/ofWi6TePZQo"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  title="Client Feedback 1"
                ></iframe>
              </div>

              <div className="col-lg-4">
                <iframe
                  width="100%"
                  height="310"
                  src="https://www.youtube.com/embed/3iJH9el9dzQ"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  title="Client Feedback 2"
                ></iframe>
              </div>

              <div className="col-lg-4">
                <iframe
                  width="100%"
                  height="310"
                  src="https://www.youtube.com/embed/Hfh01auRGAw"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  title="Client Feedback 3"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
      {/* Brands Section */}
      <Brands1 />
<div className="b-plans-holder section-about1">
      <div className="container">
        <center>
          <div className="p-sz" style={{ marginTop: "20px" }}>
            <p style={{ fontSize: "17px" }}>
              <a
                href="https://www.digitalindialeader.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaLongArrowAltRight style={{ marginRight: "5px" }} />
                Know more
              </a>{" "}
              about various digital marketing solutions & services offered by
              Digital India Leader - A digital marketing wing of ISOLS Group
            </p>
          </div>
        </center>
      </div>
    </div>
    </div>
  );
};

export default PayPerClick;
